document.addEventListener('DOMContentLoaded', function () {
  let lastCount = 0; // track previous count so we know when we FIRST go over the limit

  // ----- Figure out limit based on URL (mini / full / max) -----
  const path = window.location.pathname.toLowerCase();
  let LIMIT = 6; // default = Mini

  if (path.includes('full')) LIMIT = 10;
  if (path.includes('max'))  LIMIT = 15;

  // Counter message element
  const msg = document.querySelector('#charm-counter');

  // Product form (cover both common patterns)
  const form = document.querySelector('product-form form, form[action*="/cart/add"]');

  // Add to cart button (try inside form first, then fallbacks)
  let addBtn = null;
  if (form) {
    addBtn =
      form.querySelector('button[type="submit"]') ||
      form.querySelector('[type="submit"][name="add"]') ||
      form.querySelector('button[name="add"]');
  }
  if (!addBtn) {
    addBtn =
      document.querySelector('button[name="add"]') ||
      document.querySelector('button.add-to-cart') ||
      document.querySelector('button[type="submit"][form]');
  }

  // ----- Count selected charms (with optional quantity) -----
  function countCharms() {
    let total = 0;

    // Look at EACH checked charm tile, not just the field
    const checkedInputs = document.querySelectorAll(
      '.charm-option input[type="checkbox"]:checked, ' +
        '.charm-option input[type="radio"]:checked'
      );

    checkedInputs.forEach(function (input) {
      let qty = 1;

      // Find the containing option block
      const opt = input.closest('.charm-option');

      if (opt) {
        // Optional quantity input in that block
        const qtyInput =
          opt.querySelector('.charm-qty') ||
          opt.querySelector('input[type="number"]') ||
          opt.querySelector('input[type="text"][inputmode="numeric"]');

      if (qtyInput) {
        const parsed = parseInt(qtyInput.value || '1', 10);
          if (!Number.isNaN(parsed) && parsed > 0) {
            qty = parsed;
          }
        }
      }

      total += qty;
    });

    return total;
  }

function updateMessage() {
    const count = countCharms();

    // --- Update message text + color ---
    if (msg) {
        if (count > LIMIT) {
            const over = count - LIMIT;
            msg.textContent = `Please remove ${over} charm${over === 1 ? '' : 's'} to continue.`;
            msg.classList.add('charm-error');
        } else {
            msg.textContent = `Charms selected: ${count} / ${LIMIT}`;
            msg.classList.remove('charm-error');
        }
    }

    // --- Disable Add to Cart when over limit ---
    if (addBtn) {
        if (count > LIMIT) {
            addBtn.disabled = true;
            addBtn.classList.add('is-disabled');
        } else {
            addBtn.disabled = false;
            addBtn.classList.remove('is-disabled');
        }
    }

    // --- NEW: Auto-scroll ONLY when you JUST went over the limit ---
    if (msg && lastCount <= LIMIT && count > LIMIT) {
        msg.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    // Save last count for next time
    lastCount = count;
}

  // ----- Block submit when over limit + scroll to counter -----
  function handleSubmit(e) {
    const count = countCharms();
    if (count > LIMIT) {
      e.preventDefault();
      updateMessage();
      if (msg) {
        msg.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }

  // Recalculate when anything changes
  document.addEventListener('change', updateMessage, true);
  document.addEventListener('input', updateMessage, true);

  if (form) {
    form.addEventListener('submit', handleSubmit);
  }

  // When user clicks Add to cart while over limit, scroll to the counter
  if (addBtn) {
    addBtn.addEventListener('click', function (e) {
      const count = countCharms();
      if (count > LIMIT && msg) {
        e.preventDefault();
          msg.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    });
  }

  // initial render
  updateMessage();
});